import { createAction } from '@reduxjs/toolkit'
import type { AIModelsAccessDecision } from '@/services/ai/aiAccessPolicy'
import type { GeneratedObjectRecord, PoseTile, RepoEntry } from '@/scenes/engine/utils/aiFashionSession'
import type {
  AIFashionResultSource,
  AIFashionSessionParams,
  ImageQuality,
  VideoDuration,
  VideoResolution,
} from './types'

export const resetAIFashionState = createAction('aiFashion/reset')

export const cancelAIFashion = createAction('aiFashion/cancel')

export const setAIFashionSessionParams = createAction<Partial<AIFashionSessionParams>>(
  'aiFashion/setSessionParams',
)

export const enterAIFashionEntry = createAction('aiFashion/enterEntry')

export const startAIFashionLoading = createAction<{
  now: number
}>(
  'aiFashion/startLoading',
)

export const setAIFashionReady = createAction('aiFashion/setReady')

export const setAIFashionError = createAction<string>(
  'aiFashion/setError',
)

export const setAIFashionAccessDecision = createAction<AIModelsAccessDecision | null>(
  'aiFashion/setAccessDecision',
)

export const upsertAIFashionResult = createAction<{
  objectId: string
  record: GeneratedObjectRecord
  source?: AIFashionResultSource
}>('aiFashion/upsertResult')

export const deleteAIFashionResult = createAction<string>('aiFashion/deleteResult')

export const setAIFashionResultQuality = createAction<{
  resultId: string
  quality: ImageQuality
  hdEntry?: RepoEntry
}>('aiFashion/setResultQuality')

export const addAIFashionVideoResult = createAction<{
  objectId: string
  videoUrl: string
  sourceResultId: string
  insertAfterId?: string
  resolution: VideoResolution
  duration: VideoDuration
}>('aiFashion/addVideoResult')

export const setVideoLoadingAfterId = createAction<string | null>('aiFashion/setVideoLoadingAfterId')

export const setAIFashionSelectedResultId = createAction<string | null>(
  'aiFashion/setSelectedResultId',
)

export const setAIFashionPoseTiles = createAction<{
  tiles: PoseTile[]
  loading?: boolean
  loadingMore?: boolean
}>('aiFashion/setPoseTiles')

export const setAIFashionPostGenerationPrompt = createAction<string | null>(
  'aiFashion/setPostGenerationPrompt',
)
